// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".iconBox[data-v-6e4b4694]{margin-right:10px}.valTitle[data-v-6e4b4694]{font-size:14px;padding-bottom:10px;color:#333}.liBox[data-v-6e4b4694]{font-size:12px;color:#006dcc;line-height:16px;padding-left:6px;cursor:pointer}", ""]);
// Exports
module.exports = exports;
